export default "__VITE_ASSET__CQ6HlBC7__"